import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  closeAlert() {
    $(this.element).hide();
  }
}
